import { render, staticRenderFns } from "./loc-type-carousel.vue?vue&type=template&id=0c729711&"
import script from "./loc-type-carousel.vue?vue&type=script&lang=js&"
export * from "./loc-type-carousel.vue?vue&type=script&lang=js&"
import style0 from "./loc-type-carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports